export default __webpack_public_path__ + "static/media/img-0424-belarus-half-face.9de08e3e.png";